export interface IHelpPageModel {
	helpPageId: string;
	helpPageHTML: string;
}

export class HelpPageModel implements IHelpPageModel {
	helpPageId: string;
	helpPageHTML: string;
}